import { createSlice } from '@reduxjs/toolkit';
import {
    googleLogin,
    login,
    register,
    verifyCaptcha,
    otpLoginByMail,
    submitOtpToResetPassword,
    changePassword,
    otpRegisterByMail,
    submitOtpForRegistration
    // addReview
} from '../../../../API/Auth';
import {
    verifyInstructorCaptcha,
    loginInstructor,
    googleLoginForInstructor,
    otpRegisterByMailInstructor,
    submitOtpForRegistrationInstructor
} from '../../../../API/InstructorAuth';

const initialState = {
    loading: false,
    userInfo: null,
    userToken: null,
    error: null,
    success: false,
    alreadyExists: null,
    isGoogleRegister: null,
    googleProfile: {},
    userProfile: {},
    userProfile: {},
    captchaSuccess: false,
    captchaSuccessInstructor: false,
    registrationOtpVerified: false,
    registrationOtpSent: false,
    activeViewMode: 'LEARNER',
    changePassOtp: '',
    enrolledCourseIds: [],
    isInstructorOnboarded: false,
    isOnboarded: null,
    alreadyInstructor: null,
    platformSettings: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        //logout reducer
        logout: (state) => {
            state.loading = false;
            state.userInfo = null;
            state.userToken = null;
            state.error = null;
            state.success = false;
            state.captchaSuccess = false;
            state.captchaSuccessInstructor = false;
            state.registrationOtpSent = false;
            state.registrationOtpVerified = false;
            state.alreadyExists = null;
            state.activeViewMode = 'LEARNER';
            state.isOnboarded = false;
            state.alreadyInstructor = null;
        },
        setActiveViewMode: (state, { payload }) => {
            state.activeViewMode = payload;
        },
        toggleForgotPassword: (state) => {
            state.forgotPassword = !state.forgotPassword;
        },
        setGoogleProfile: (state, { payload }) => {
            state.googleProfile = payload;
        },
        setUserProfile: (state, { payload }) => {
            const val = payload && Object.keys(payload).length > 0 ? payload : null;
            state.userProfile = val;
            state.userInfo = val;
        },
        setUserInfo: (state, { payload }) => {
            state.userInfo = payload && Object.keys(payload).length > 0 ? payload : null;
        },
        setUserToken: (state, { payload }) => {
            state.loading = false;
            if (payload) {
                if (payload.data !== undefined) {
                    state.userInfo = payload.data;
                }
                const tokenVal = payload.token !== undefined ? payload.token : payload;
                state.userToken =
                    tokenVal && typeof tokenVal === 'string'
                        ? { token: tokenVal }
                        : tokenVal;
            } else {
                state.userToken = null;
            }
            state.success = true;
        },
        setUserSuccess: (state, { payload }) => {
            state.success = true;
        },
        setUserSuccessFalse: (state, { payload }) => {
            state.success = false;
        },
        setUserTokenPayload: (state, { payload }) => {
            state.userToken =
                payload && typeof payload === 'string'
                    ? { token: payload }
                    : payload;
        },
        setRegistrationOtpSent: (state, { payload }) => {
            state.registrationOtpSent = payload;
        },
        setIsOnboarded: (state) => {
            state.isOnboarded = true;
        },

        setChangePassOtp: (state, { payload }) => {
            state.changePassOtp = payload;
        },
        setEnrolledCourseIds: (state, { payload }) => {
            state.enrolledCourseIds = payload;
            if (state.userInfo?.enrolledCourses) {
                state.userInfo.enrolledCourses =
                    state.userInfo.enrolledCourses.filter((c) => {
                        const id =
                            c && typeof c === 'object' && c._id
                                ? String(c._id)
                                : String(c);
                        return payload.map(String).includes(id);
                    });
            }
        },
        removeEnrolledCourse: (state, { payload }) => {
            if (state.userInfo?.enrolledCourses) {
                state.userInfo.enrolledCourses =
                    state.userInfo.enrolledCourses.filter((c) =>
                        c && typeof c === 'object' && c._id
                            ? String(c._id) !== String(payload)
                            : String(c) !== String(payload)
                    );
            }
            if (state.enrolledCourseIds) {
                state.enrolledCourseIds = state.enrolledCourseIds.filter(
                    (id) => String(id) !== String(payload)
                );
            }
        },
        addEnrolledCourseId: (state, { payload }) => {
            if (Array.isArray(payload)) {
                payload.forEach((id) => {
                    if (!state.enrolledCourseIds.includes(id)) {
                        state.enrolledCourseIds.push(id);
                    }
                });
            } else {
                if (!state.enrolledCourseIds.includes(payload)) {
                    state.enrolledCourseIds.push(payload);
                }
            }
        },
        setInstructorSuccess: (state) => {
            state.success = true;
        },
        setInstructorSuccessTrue: (state) => {
            state.success = true;
        },
        setIsInstructorOnboarded: (state, { payload }) => {
            state.isInstructorOnboarded = payload;
        },
        setRegistrationOtpSentInstructor: (state, { payload }) => {
            state.registrationOtpSent = payload;
        },
        setPlatformSettings: (state, { payload }) => {
            state.platformSettings = payload;
        },
        clearAuthError: (state) => {
            state.error = null;
        }
    },
    extraReducers: {
        //captcha verification reducer
        [verifyCaptcha.pending]: (state) => {
            (state.loading = true),
                (state.error = null),
                (state.captchaSuccess = false);
        },
        [verifyCaptcha.fulfilled]: (state, { payload }) => {
            (state.loading = false),
                (state.captchaSuccess = payload?.data?.data?.success),
                (state.error = null);
            // state.success = true;
        },
        [verifyCaptcha.rejected]: (state, { payload }) => {
            (state.loading = false),
                (state.error = payload),
                (state.captchaSuccess = false);
        },

        //login reducer
        [login.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
            state.captchaSuccess = false;
        },
        [login.fulfilled]: (state, { payload }) => {
            // console.log('payload', payload);
            state.loading = false;
            state.userInfo = payload.data;
            state.userToken =
                payload.token && typeof payload.token === 'string'
                    ? { token: payload.token }
                    : payload.token;
            state.alreadyExists = true;
            state.success = payload.status;
            state.captchaSuccess = false;
            state.alreadyInstructor = payload?.data?.alreadyInstructor || null;
            state.isOnboarded = true;
            // state.error = payload;
        },
        [login.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
            state.captchaSuccess = false;
        },

        //google oauth reducers
        [googleLogin.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
            state.alreadyExists = null;
        },
        [googleLogin.fulfilled]: (state, { payload }) => {
            // console.log('payload', payload);
            state.loading = false;
            state.userInfo = payload.user;
            state.userToken =
                payload.token && typeof payload.token === 'string'
                    ? { token: payload.token }
                    : payload.token;
            state.alreadyExists = payload.alreadyExist;
            state.isGoogleRegister = true;
            state.success = payload.status;
            state.alreadyInstructor = payload?.user?.alreadyInstructor || null;
            if (payload.alreadyExist) {
                state.isOnboarded = true;
            } else {
                state.isOnboarded = false;
            }
        },
        [googleLogin.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
            state.alreadyExists = null;
        },

        // register reducer
        [register.pending]: (state) => {
            (state.loading = true),
                (state.error = null),
                (state.success = false);
        },
        [register.fulfilled]: (state, { payload }) => {
            // console.log('payload', payload);
            state.loading = false;
            state.userInfo = payload.data;
            state.userToken =
                payload.token && typeof payload.token === 'string'
                    ? { token: payload.token }
                    : payload.token;
            state.alreadyExists = false;
            state.isGoogleRegister = false;
            state.success = payload.status;
            state.alreadyInstructor = payload?.data?.alreadyInstructor || null;
            state.isOnboarded = false;
        },
        [register.rejected]: (state, { payload }) => {
            (state.loading = false),
                (state.error = payload),
                (state.success = false);
        },

        // New reducer for handling forgotPassword action
        [otpLoginByMail.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        [otpLoginByMail.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            // state.success = payload.status;
        },
        [otpLoginByMail.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
        },

        // New reducer for handling forgotPassword action
        [otpRegisterByMail.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        [otpRegisterByMail.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.registrationOtpSent = true;
        },
        [otpRegisterByMail.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
        },

        [otpRegisterByMailInstructor.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        [otpRegisterByMailInstructor.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.registrationOtpSentInstructor = true;
        },
        [otpRegisterByMailInstructor.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
        },

        // New reducer for handling OTP submission action
        [submitOtpToResetPassword.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        [submitOtpToResetPassword.fulfilled]: (state) => {
            state.loading = false;
            state.error = null;
            // state.success = true;
        },
        [submitOtpToResetPassword.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
        },

        // New reducer for handling OTP submission action
        [submitOtpForRegistration.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        [submitOtpForRegistration.fulfilled]: (state, { payload }) => {
            // console.log('payload', payload);
            state.loading = false;
            state.userInfo = payload.data;
            state.userToken =
                payload.token && typeof payload.token === 'string'
                    ? { token: payload.token }
                    : payload.token;
            state.alreadyExists = false;
            state.isGoogleRegister = false;
            state.success = payload.status;
            state.alreadyInstructor = payload?.data?.alreadyInstructor || null;
            state.isOnboarded = false;
        },
        [submitOtpForRegistration.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
        },

        [submitOtpForRegistrationInstructor.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        [submitOtpForRegistrationInstructor.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.userInfo = payload.data;
            state.userToken =
                payload.token && typeof payload.token === 'string'
                    ? { token: payload.token }
                    : payload.token;
            state.alreadyExists = false;
            state.isGoogleRegister = false;
            state.success = payload.status;
            state.alreadyInstructor = payload?.data?.alreadyInstructor || null;
            state.isOnboarded = false;
        },
        [submitOtpForRegistrationInstructor.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
        },

        // reducer for handling change password
        [changePassword.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        [changePassword.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.error = null;
            state.success = true;
            if (payload?.token) {
                state.userToken =
                    payload.token && typeof payload.token === 'string'
                        ? { token: payload.token }
                        : payload.token;
            }
            if (
                payload?.data &&
                typeof payload.data === 'object' &&
                !Array.isArray(payload.data) &&
                (payload.data._id || payload.data.email)
            ) {
                state.userInfo = payload.data;
                state.userProfile = payload.data;
            }
        },
        [changePassword.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error =
                typeof payload === 'string'
                    ? payload
                    : payload?.message || 'Failed to change password';
            state.success = false;
        },

        // verifyInstructorCaptcha reducers
        [verifyInstructorCaptcha.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.captchaSuccessInstructor = false;
        },
        [verifyInstructorCaptcha.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.captchaSuccessInstructor = payload?.data?.data?.success;
            state.error = null;
        },
        [verifyInstructorCaptcha.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.captchaSuccessInstructor = false;
        },

        // loginInstructor reducers
        [loginInstructor.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
            state.captchaSuccessInstructor = false;
        },
        [loginInstructor.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.userInfo = payload.data;
            state.userToken =
                payload.token && typeof payload.token === 'string'
                    ? { token: payload.token }
                    : payload.token;
            state.alreadyExists = true;
            state.success = payload.status;
            state.captchaSuccessInstructor = false;
            state.alreadyInstructor = payload?.data?.alreadyInstructor || null;
            state.isOnboarded = true;
        },
        [loginInstructor.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
            state.captchaSuccessInstructor = false;
        },

        // googleLoginForInstructor reducers
        [googleLoginForInstructor.pending]: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
            state.alreadyExists = null;
        },
        [googleLoginForInstructor.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.userInfo = payload.user;
            state.userToken =
                payload.token && typeof payload.token === 'string'
                    ? { token: payload.token }
                    : payload.token;
            state.alreadyExists = payload.alreadyExist;
            state.isGoogleRegister = true;
            state.success = payload.status;
            state.alreadyInstructor = payload?.user?.alreadyInstructor || null;
            if (payload.alreadyExist) {
                state.isOnboarded = true;
            } else {
                state.isOnboarded = false;
            }
        },
        [googleLoginForInstructor.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
            state.success = false;
            state.alreadyExists = null;
        }
    }
});

export const { setChangePassOtp } = authSlice.actions;

export const {
    logout,
    setGoogleProfile,
    setUserProfile,
    setUserInfo,
    setUserToken,
    setUserSuccess,
    setUserTokenPayload,
    setUserSuccessFalse,
    setRegistrationOtpSent,
    setIsOnboarded,
    setActiveViewMode,
    changePassOtp,
    setEnrolledCourseIds,
    addEnrolledCourseId,
    removeEnrolledCourse,
    setInstructorSuccess,
    setInstructorSuccessTrue,
    setIsInstructorOnboarded,
    setRegistrationOtpSentInstructor,
    setPlatformSettings,
    clearAuthError
} = authSlice.actions;
export default authSlice.reducer;
